function Logo({ logo_url, logo_position, logo_size, classes }) {
  const getLogoSizeClasses = (size, position) => {
    switch (size) {
      case "Large":
        return position === "bottom"
          ? "max-w-[350px] my-1"
          : "max-w-[400px] my-5";
      case "Medium":
        return position === "bottom"
          ? "max-w-[250px] my-1"
          : "max-w-[300px] my-5";
      case "Small":
        return position === "bottom"
          ? "max-w-[150px] my-1"
          : "max-w-[200px] my-5";
      default:
        return "max-w-full";
    }
  };

  const logoClasses = `${getLogoSizeClasses(
    logo_size,
    logo_position
  )} ${classes}`;

  return (
    <div className="text-center w-full max-w-screen-xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="flex justify-left">
        <img src={logo_url} alt="Logo" className={logoClasses} />
      </div>
    </div>
  );
}

export default Logo;
